import { Injectable } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {ConfirmationDialogComponent} from "@app/commons/confirmation-dialog/confirmation-dialog.component.ts";

@Injectable() export class ConfirmationDialogService {
    dialogRef: MatDialogRef<any>;
    dialogConfig = new MatDialogConfig();
    constructor(public dialog: MatDialog) {}

    openDialog(title:string,message:string){
        this.dialogConfig.data = {data: title,message}
        this.dialogConfig.width = '400px';
        this.dialogConfig.height = 'auto';
        this.dialogRef = this.dialog.open(ConfirmationDialogComponent, this.dialogConfig);
        return this.dialogRef.afterClosed();
    }
}
